// 封装后台接口方法
import { get, post, put } from "./http";
export const GET_NEWS = (params) => get(`/luxetcn/newss/?${params}`);
export const GET_COMMENTS = (params) => post("/luxetcn/comments/", params);

export const GET_NEWS_ID = (params) => get(`/luxetcn/newss/${params}/`);
export const REGISTER = (params) =>
  put("service-core/user_register", params, false);
